<template>
  <div class="topInstallBar" v-if="show">
    <span class="w-[38px]" @click="hide"></span>
    <div class="flex-1 flex-center">
      <Image :src v-if="src" class="h-full" alt=""/>
    </div>
    <Installation v-slot="{ start }">
      <span class="w-[100px]" @click="start"></span>
    </Installation>
  </div>
</template>

<script setup lang="ts">
  import { useHomeBannersAndTexts } from '@/store'
  import Installation from '@a/components/Installation/index.vue'
  const show = ref(false)
  const src = computed(() => useHomeBannersAndTexts().topDownload?.asset)

  watch(src, (val) => {
      show.value = !!val
  }, { immediate: true })
  
  const hide = () => {
    show.value = false
    sessionStorage.setItem('topInstallBar', '0')
  }
  
  const router = useRouter()
  if (router.currentRoute.value.path === '/home') {
    sessionStorage.removeItem('topInstallBar')
  } else {
    if (sessionStorage.getItem('topInstallBar') === '0') {
      show.value = false
    }
  }
</script>

<style lang="scss">
.topInstallBar{
  @apply flex w-full h-[44px] shadow-md bgs-[var(--topInstallBar-bg),center_top] relative z-[1999];
}
</style>
